// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"108":"5124d35ddeafed5e9d1f","452":"1a6c0e426670a68bb6bd"}[chunkId] + ".js";
};